import React, { useContext, useEffect, useState } from 'react';
import { Context as UserContext } from '../context/UserContext';
import styled from 'styled-components';
import { Context as AttendantContext } from '../context/AttendantContext';
import SiteData from '../config';

const SliderPageRightPane = ({ className }) => {
  const {
    state,
    state: { user, user: { first_name, screen_name } = {} } = {},
    setUser,
  } = useContext(UserContext);
  const { state: { attendant = undefined } = {}, setAttendant } = useContext(
    AttendantContext
  );
 
  const [iFrameLink, setIFrameLink] = useState(null);

  useEffect(() => {
    // const displayName = screen_name || first_name;
    const displayName =
      screen_name && screen_name !== 'None' ? screen_name : first_name;
    console.log('SN OR FIRST NAME', screen_name, first_name);
    if (displayName) {
      console.log('link set')
      setIFrameLink(
        `https://deadsimplechat.com/GMQPXW4VK?username=${displayName}`
      );
      console.log('display name', displayName)
      
    }
  }, [first_name, screen_name]);


  return (
    <div className={className}>
      {iFrameLink && <iframe src={iFrameLink} />}
      
    </div>
  );
};

export default styled(SliderPageRightPane)`
  height: 94%;
  color: black;
  overflow: hidden;

  iframe {
    overflow: hidden;
  }
`;
